import { updates } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-2">
            🍉 吃瓜快讯
          </h2>
          <p className="text-sm text-foreground-500">实时更新最新爆料动态，不错过每一个瓜</p>
        </div>
        <div className="max-w-[800px] mx-auto relative">
          <div className="absolute left-[19px] md:left-[23px] top-2 bottom-2 w-[2px] bg-background-200"></div>
          <div className="space-y-0">
            {updates.map((item) => (
              <div key={item.id} className="relative flex items-start gap-4 md:gap-5 pb-5 md:pb-6 last:pb-0 pl-10 md:pl-12">
                <div className="absolute left-2 md:left-[5px] top-1.5 w-3 h-3 rounded-full border-2 border-accent-500 bg-background-50"></div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                    <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 whitespace-nowrap">
                      {item.category}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}